import {Action} from '@reduxjs/toolkit';
import {ForkEffect, call, put, takeLatest} from 'redux-saga/effects';

import * as log from '../../../../logger';
import {
  getAuthenticationToken,
  removeAuthenticationToken,
  getAuthenticationTokenFromUrl,
  removeAuthenticationTokenFromUrl,
  autoAuthenticate,
} from '../userApi';
import {autoAuthenticationDone} from '../userSlice';

import {requestLogin} from './loginSaga';

function requestAutoAuthentication(): Action<'user/requestAutoAuthentication'> {
  return {
    type: 'user/requestAutoAuthentication',
  };
}

function* requestAutoAuthenticationSaga() {
  const token: string = yield call(getAuthenticationToken);
  const tokenFromUrl: string = yield call(getAuthenticationTokenFromUrl);
  const autoAuthenticationToken = tokenFromUrl || token;

  if (autoAuthenticationToken) {
    try {
      const {token, user} = yield call(
        autoAuthenticate,
        autoAuthenticationToken,
      );
      const credentials = {
        user,
        organization: user.organization,
      };

      yield put(requestLogin({token, credentials}));
    } catch (error) {
      yield call(removeAuthenticationToken);
      if (error instanceof Error) {
        yield call(log.exception, error);
      }
    }
  }

  yield call(removeAuthenticationTokenFromUrl);
  yield put(autoAuthenticationDone());
}

function* watchRequestAutoAuthentication(): Generator<
  ForkEffect<void>,
  void,
  unknown
> {
  yield takeLatest(
    'user/requestAutoAuthentication',
    requestAutoAuthenticationSaga,
  );
}

export {requestAutoAuthentication};

export default watchRequestAutoAuthentication;
